

export function getNumberStringPrecision(value: string): number {
    return value.split('.')[1]?.length ?? 0;
}
